/*eslint no-unused-vars:0 */
import UserAgreementTemplate from './UserAgreementTemplate';
import ImageLoopTemplate from './ImageLoopTemplate';
import _ from 'lodash'

const TEMPLATES = {
	'UserAgreementTemplate': UserAgreementTemplate,
	'ImageLoopTemplate': ImageLoopTemplate
};
// Don't forget to add to Experiment.js > AddScreenDialog



export default class Template{
	constructor(templateClass, app){
		this.app = app;
		const TemplateClass = TEMPLATES[templateClass];
		this.template = new TemplateClass(this.app);
	}
	
	async getScreens(){
		return this.template.getScreens();
	}

	getDefaultScreen(){

	}
};




// WEBPACK FOOTER //
// ./src/models/templates/Template.js